<template>
  <v-card>
    <!-- tab control -->
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Cotizaciones</div>
      <div>
        <v-tabs v-model="currentTab">
          <v-tab :disabled="editMode === 'edit' || editMode === 'new'">
            Lista
          </v-tab>
          <v-tab :disabled="!currentItem">Edición</v-tab>
        </v-tabs>
      </div>
      <div v-show="currentTab === 1">
        <v-btn
          v-show="editMode !== 'show'"
          :disabled="onAction == true"
          color="warning"
          outlined
          @click="cancel"
          class="mx-2"
        >
          Cancelar
        </v-btn>
        <v-btn
          v-show="editMode === 'show' && canEdit"
          :disabled="onAction == true"
          color="success"
          outlined
          @click="edit"
          class="mx-2"
        >
          Editar
        </v-btn>
        <v-btn
          v-show="editMode === 'show' && canPrint"
          :disabled="onAction == true"
          color="primary"
          outlined
          @click="duplicate"
          class="mx-2"
        >
          Duplicar
        </v-btn>
        <v-btn
          v-show="editMode !== 'show'"
          :disabled="onAction == true"
          color="success"
          outlined
          @click="save"
          class="mx-2"
        >
          Guardar
        </v-btn>
        <v-btn
          v-show="editMode == 'show' && canEdit"
          :disabled="onAction == true"
          color="warning"
          outlined
          @click="archive"
          class="mx-2"
        >
          Anular
        </v-btn>
        <v-btn
          v-show="editMode == 'show' && canPrint"
          :disabled="onAction == true"
          color="success"
          outlined
          @click="printClient"
          class="mx-2"
        >
          <v-icon class="pa-2">
            mdi-printer
          </v-icon>
          Cliente
        </v-btn>
        <v-btn
          v-show="editMode == 'show' && canPrint"
          :disabled="onAction == true"
          color="warning"
          outlined
          @click="printInternal"
          class="mx-2"
        >
          <v-icon class="pa-2">
            mdi-printer
          </v-icon>
          Interno
        </v-btn>
      </div>
    </v-card>
    <!-- tab0 list -->
    <v-card-text v-show="currentTab === 0">
      <v-card>
        <!-- advanced filter -->
        <v-toolbar>
          <v-autocomplete
            label="Campaña"
            :items="campaignItems"
            :loading="isLoadingCampaign"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            return-object
            v-model="selectedCampaign"
            @change="campaignSelected($event)"
            @click:prepend="clearAutocomplete('campaignAutocomplete')"
            ref="campaignAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Cultivo"
            :items="cropItems"
            :loading="isLoadingCrops"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            return-object
            v-model="selectedCrop"
            @change="cropSelected($event)"
            @click:prepend="clearAutocomplete('cropAutocomplete')"
            ref="cropAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Cliente/Productor"
            :search-input.sync="searchPerson"
            :items="personItems"
            :loading="isLoadingPerson"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="person"
            return-object
            @change="personSelected($event)"
            @click:prepend="clearAutocomplete('personAutocomplete')"
            ref="personAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Estado"
            :items="stateItems"
            :loading="isLoadingState"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            return-object
            @change="stateSelected($event)"
            @click:prepend="clearAutocomplete('stateAutocomplete')"
            ref="stateAutocomplete"
            prepend-icon="mdi-close"
          ></v-autocomplete>
        </v-toolbar>
        <!-- table header pagination and add button -->
        <div class="table-footer-prepend d-flex pl-2 align-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="!enableEditing"
                icon
                outlined
                color="primary"
                class="mr-3"
                v-on="on"
                @click="addNew()"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Agregar Cotización</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="!enableEditing"
                icon
                outlined
                color="primary"
                class="mr-3"
                v-on="on"
                @click="readDataFromAPI()"
              >
                <v-icon>mdi-sync</v-icon>
              </v-btn>
            </template>
            <span>Actualizar</span>
          </v-tooltip>
        </div>
        <!-- data table -->
        <v-data-table
          dense
          v-bind:page="page"
          :pageCount="this.pageCount"
          :loading="loading"
          :headers="headers"
          :items="items"
          :itemsPerPage="itemsPerPage"
          :serverItemsLength="serverItemsLength"
          :options.sync="options"
          @click:row="itemSelected($event, false)"
        >
          <template v-slot:top="{ options, updateOptions }">
            <div class="table-footer-append d-flex align-center justify-end">
              <span class="mr-2">{{ getPaginationSummary() }}</span>
              <v-btn
                icon
                small
                class="mr-1"
                :disabled="page <= 1"
                @click="updateOptions(Object.assign({}, options, { page: 1 }))"
              >
                <v-icon>mdi-page-first</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                class="mr-1"
                :disabled="page <= 1"
                @click="updateOptions(Object.assign({}, options, { page: page - 1 }))"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                class="mr-1"
                :disabled="page >= pageCount"
                @click="updateOptions(Object.assign({}, options, { page: page + 1 }))"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <v-btn
                icon
                small
                class="ml-0"
                :disabled="page >= pageCount"
                @click="updateOptions(Object.assign({}, options, { page: pageCount }))"
              >
                <v-icon>mdi-page-last</v-icon>
              </v-btn>
            </div>
          </template>
          <template v-slot:[`item.visual_state`]="{ item }">
            <v-icon small class="mr-2">
              {{ item.state_icon }}
            </v-icon>
            <span>{{ item.state_description }} </span>
          </template>
        </v-data-table>
      </v-card>
    </v-card-text>
    <!-- tab1 edit pedido -->
    <div v-if="currentTab === 1">
      <quotation-edit
        :initialmode="editMode"
        :value="currentItem"
        :key="currentTab"
        ref="itemEdit"
        @endEdit="endEdit"
        @actionCanceled="actionCanceled"
        @objectChange="itemSelected"
      >
      </quotation-edit>
    </div>
  </v-card>
</template>
<script>
import DataQuotation from "@/components/clon/DataQuotation.js";
import QuotationEdit from "@/components/QuotationEdit.vue";

export default {
  name: "Quotation",

  components: {
    QuotationEdit
  },

  data() {
    return {
      currentTab: 0,
      editMode: "show",
      defaultOrder: "-id",
      currentItem: null,
      searchPerson: null,
      personItems: [],
      campaignItems: [],
      stateItems: [],
      cropItems: [],
      lastEndpoint: null,
      selectedCampaign: null,
      selectedCrop: null,
      isLoadingPerson: false,
      isLoadingCampaign: false,
      isLoadingState: false,
      isLoadingCrops: false,
      filterPerson: null,
      filterCampaign: null,
      filterState: null,
      filterCrop: null,
      loading: true,
      mounting: true,
      page: 1,
      serverItemsLength: 0,
      pageCount: 0,
      itemsPerPage: 20,
      options: {},
      items: [],
      quotation: new DataQuotation(this.$bRoot),
      enableEditing: false,
      canEdit: false,
      canPrint: false,
      onAction: false,
      headers: [
        { text: "id", value: "id", sortable: false },
        { text: "Fecha", value: "date_formatted", sortable: false },
        {
          text: "Usuario",
          value: "commercial_person_name",
          sortable: false,
          width: "10%"
        },
        {
          text: "Cliente/Productor",
          value: "person_name",
          sortable: false,
          width: "20%"
        },
        {
          text: "Comisión Total USD",
          value: "total_commission_usd",
          sortable: false,
          align: "right",
          width: "10%"
        },
        {
          text: "Condición de Pago",
          value: "payment_condition_description",
          width: "15%",
          sortable: false
        },
        {
          text: "Estado",
          value: "visual_state",
          sortable: false,
          width: "15%"
        }
      ],
      canDelete: false,
      downloading: false
    };
  },

  //this one will populate new data set when user changes current page.
  watch: {
    options: {
      handler(options) {
        let order_by = "";
        let order_desc = 0;

        if (options.sortBy.length > 0) {
          order_by = options.sortBy[0];
          order_desc = options.sortDesc[0] ? 1 : 0;
        } else {
          order_by = this.defaultOrder;
          order_desc = 0;
        }
        this.readDataFromAPI(false, order_by, order_desc);
      }
    },
    searchPerson: {
      handler(val) {
        this.doIntelliSearch("person", val);
      }
    },
    deep: true
  },

  methods: {
    //Reading data from API method.
    async readDataFromAPI(reset, order_by, order_desc) {
      if (!this.mounting) {
        try {
          this.loading = true;
          this.items = [];
          if (this.filterCampaign) {
            if (!order_by) {
              order_by = this.defaultOrder;
            } else {
              order_by = (order_desc == 1 ? "-" : "") + order_by;
            }
            const { page, itemsPerPage } = this.options;
            let pageNumber = reset ? 1 : page;
            this.loading = true;
            let campaign_id = this.filterCampaign ? this.filterCampaign.id : 0;
            let person_id = this.filterPerson ? this.filterPerson.id : 0;
            let state_id = this.filterState ? this.filterState.id : 0;
            let crop_id = this.filterCrop ? this.filterCrop.id : 0;

            let res = await this.quotation.search(
              campaign_id,
              person_id,
              state_id,
              crop_id,
              order_by,
              pageNumber
            );
            if (this.$bRoot.errors) {
              throw "Error recuperando datos";
            }
            if (res) {
              this.items = res.data.results;
              this.serverItemsLength = res.data.count;
              this.page = pageNumber;
              this.pageCount = Math.ceil(res.data.count / itemsPerPage);
            }
          }
        } catch (error) {
          if (!this.$bRoot.errors) {
            this.$bRoot.setError(error);
          }
        } finally {
          this.loading = false;
        }
      }
    },

    doIntelliSearch(field, val) {
      // Items have already been requested
      if (this.isLoading) return;

      // Lazily load input items
      let endpoint = null;
      let searchstring = null;
      let filterstring = null;
      let ordering = null;

      switch (field) {
        case "person":
          if (this.filterPerson) {
            if (this.filterPerson.name === val) return;
          }
          endpoint =
            "/data/quotable_persons_hierarchy" +
            "/" +
            (this.filterCampaign ? this.filterCampaign.id.toString() : 0) +
            "/" +
            (val ? val : "_");
          this.isLoadingPerson = true;
          break;
      }

      // eslint-disable-next-line
      this.$bRoot.search(endpoint, searchstring, ordering, filterstring, 1)
        .then(res => {
          switch (field) {
            case "person":
              this.personItems = res.data.results;
              break;
          }
        })
        .catch(err => {
          if (!this.$bRoot.errors) {
            this.$bRoot.setError(err);
          }
        })
        .finally(() => {
          this.isLoadingPerson = false;
        });
    },

    clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "personAutocomplete":
          this.filterPerson = null;
          break;
        case "campaignAutocomplete":
          this.filterCampaign = null;
          break;
        case "stateAutocomplete":
          this.filterState = null;
          break;
        case "cropAutocomplete":
          this.filterCrop = null;
          break;
      }
      this.readDataFromAPI(true);
    },

    personSelected(item) {
      this.filterPerson = item;
      this.readDataFromAPI(true);
    },

    async purgeCurrentCampaignState() {
      if (!this.filterCampaign) {
        return;
      }
      await this.quotation.purgeState(this.filterCampaign.code);
    },

    async campaignSelected(campaign) {
      this.filterCampaign = campaign;
      await this.purgeCurrentCampaignState();
      this.readDataFromAPI(true);
    },

    cropSelected(crop) {
      this.filterCrop = crop;
      this.readDataFromAPI(true);
    },

    stateSelected(state) {
      this.filterState = state;
      this.readDataFromAPI(true);
    },

    deleteItem(item) {
      this.$emit("deleteItem", item);
    },

    async itemSelected(item, edit) {
      this.editMode = edit ? "edit" : "show";
      let currentItem = Object.assign({}, item);
      let campaign_id = this.filterCampaign ? this.filterCampaign.id : 0;
      this.currentItem = await this.quotation.get(campaign_id, currentItem.id);
      if (this.enableEditing) {
        this.canEdit = item.can_edit;
        this.canPrint = item.can_print;
        this.canArchive = item.can_edit;
      } else {
        this.canEdit = false;
        this.canPrint = false;
        this.canArchive = false;
      }
      this.currentTab = 1;
    },

    getPaginationSummary() {
      if (this.serverItemsLength === 0) {
        return "0-0 of 0";
      }

      const fromItem = (this.page - 1) * this.itemsPerPage + 1;
      const toItem = Math.min(this.page * this.itemsPerPage, this.serverItemsLength);
      return fromItem + "-" + toItem + " of " + this.serverItemsLength;
    },

    async addNew() {
      this.currentItem = await this.quotation.initialize(
        this.filterPerson,
        this.filterCampaign,
        this.filterCrop
      );
      this.editMode = "new";
      this.currentTab = 1;
    },

    sliceObj(obj) {
      var o = {},
        keys = [].slice.call(arguments, 1);
      // eslint-disable-next-line
      for (var i=0; i<keys.length; i++) {
        if (keys[i] in obj) o[keys[i]] = obj[keys[i]];
      }
      return o;
    },

    async cancel() {
      // eslint-disable-next-line
      if (this.editMode === 'show' || await this.$confirm("Confirme que desea abandonar la edición, los datos modificados se perderán")) {
        this.endEdit();
      }
    },

    edit() {
      if (this.currentItem && this.currentTab === 1) {
        this.editMode = "edit";
        this.$refs.itemEdit.mode = "edit";
        this.$refs.itemEdit.editing = true;
      }
    },

    async duplicate() {
      if (this.currentItem && this.currentTab === 1) {
        await this.$refs.itemEdit.duplicate();
        this.editMode = "edit";
        this.$refs.itemEdit.mode = "edit";
        this.$refs.itemEdit.editing = true;
      }
    },

    async endEdit() {
      this.editMode = null;
      this.currentItem = null;
      this.error = null;
      this.currentTab = 0;
      await this.readDataFromAPI();
      this.onAction = false;
    },

    async save() {
      this.onAction = true;
      await this.$refs.itemEdit.save();
    },

    async actionCanceled() {
      this.onAction = false;
    },

    async archive() {
      //eslint-disable-next-line
      if(await this.$confirm("Confirme que desea anular la cotización, la acción no se puede revertir...")){
        this.onAction = true;
        await this.$refs.itemEdit.changeState(100);
      }
    },

    async printClient() {
      this.onAction = true;
      await this.$refs.itemEdit.printClient();
      await this.$refs.itemEdit.changeState(40);
      this.onAction = false;
      //to do
    },

    async printInternal() {
      this.onAction = true;
      await this.$refs.itemEdit.printInternal();
      this.onAction = false;
    }
  },

  async mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    // evaluete enableEditing
    this.enableEditing = true;

    //campaigns
    let campaigns = await this.quotation.getCampaigns();
    this.campaignItems = campaigns.data.results;
    let defaultCampaignId = this.$bRoot.getUserParam("defaultCampaignId");
    let index = this.campaignItems.findIndex(
      item => item.id == defaultCampaignId
    );
    if (index == -1 && this.campaignItems.length > 0) {
      index = 0;
    }
    if (index !== -1) {
      this.selectedCampaign = this.campaignItems[index].url;
      this.filterCampaign = this.campaignItems[index];
    }
    this.mounting = false;

    //crops
    let crops = await this.quotation.getCrops();
    this.cropItems = crops.data.results;
    // default value
    let default_crop_id = this.$bRoot.getUserParam("defaultCropId");
    if (default_crop_id) {
      let index = this.cropItems.findIndex(
        crop_item => crop_item.id === default_crop_id
      );
      if (index != -1) {
        this.selectedCrop = this.cropItems[index].url;
        this.filterCrop = this.cropItems[index];
      }
    }

    //states
    this.isLoadingState = true;
    let states = await this.quotation.getStates();
    this.stateItems = states.data.results;
    this.isLoadingState = false;

    //purge
    await this.purgeCurrentCampaignState();

    await this.readDataFromAPI();
  }
};
</script>

<style scoped>
.v-data-footer__select {
  display: none !important;
}
.v-data-footer:last-child {
  visibility: hidden !important;
}
.table-footer-prepend {
  height: 58px;
}
.table-footer-append {
  min-height: 58px;
}
.v-data-table {
  margin-top: -58px;
}
</style>
